/**
 * Tiny event bus (no imports, so `client.ts` can use it without a cycle): any API answer
 * 503 `{ error: "partner_panel_closed", message }` tells `PanelGate` to switch to the closed screen.
 */
type Listener = (message: string) => void;

const listeners = new Set<Listener>();

export function reportPanelClosed(message: string): void {
    listeners.forEach((l) => l(message));
}

export function onPanelClosed(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

/** 403 `rules_acceptance_required`: `RulesNotice` opens the «accept the new rules» dialog. */
const rulesListeners = new Set<() => void>();

export function reportRulesRequired(): void {
    rulesListeners.forEach((l) => l());
}

export function onRulesRequired(listener: () => void): () => void {
    rulesListeners.add(listener);
    return () => rulesListeners.delete(listener);
}
